import loadable from "@loadable/component"
import { RouteObject } from "react-router-dom"

import { APP_ROUTES } from "~/shared/constants/routes"

const PickupBolPage = loadable(
  async () => import("~/features/pickup-bol/pages/PickupBolPage"),
  { fallback: <></> },
)

export const pickupBolRoutes: RouteObject[] = [
  {
    path: APP_ROUTES.pickupBol,
    element: <PickupBolPage />,
  },
]
